/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLocaleConsentAcceptanceInternal} from '../api'

 export const useQueryGetLocaleConsentAcceptanceInternal = createReactQueryHook('getLocaleConsentAcceptanceInternal', getLocaleConsentAcceptanceInternal)
